
export default  [
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-custom',
        field: 'id_emp',
        label: 'Selecione a Empresa',
        placeholder:'Selecione',
        option: {
            key: 'id',
            label: 'nome',
            value: 'id'
        },
        info: 'Selecione a empresa que deseja desativar o envio dos periódicos.',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-custom',
        field: 'id_fun',
        label: 'Funcionário',
        placeholder: 'Todos',
        option: {
            key: 'id',
            label: 'funcionario',
            value: 'id'
        },
        multiple: true,
        info: 'Selecione a empresa que deseja desativar o envio dos periódicos.',
        rules: ['']
    },
];




// WEBPACK FOOTER //
// ./src/components/apps/web/periodico/desativado/_form/periodico-desativado-cadastrar.js